
/**
 * @roxi/routify 2.7.3
 * File generated Mon Dec 14 2020 16:12:05 GMT+0000 (Coordinated Universal Time)
 */

export const __version = "2.7.3"
export const __timestamp = "2020-12-14T16:12:05.183Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes"

//imports


//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "isFallback": true,
      "path": "/_fallback",
      "component": () => import('../src/pages/_fallback.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "ext": "md",
              "isPage": true,
              "meta": {
                "frontmatter": {
                  "title": "Routify and NetlifyCMS",
                  "text": "IT'S WORKING! I'm writing this from NetlifyCMS"
                },
                "recursive": true,
                "preload": false,
                "prerender": true
              },
              "path": "/cms/homepage/content",
              "id": "_cms_homepage_content",
              "component": () => import('../src/pages/cms/homepage/content.md').then(m => m.default)
            }
          ],
          "path": "/cms/homepage"
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "ext": "md",
              "isPage": true,
              "meta": {
                "frontmatter": {
                  "title": "Markdown",
                  "text": "# Titles\n\nParagraphs about Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis necessitatibus ipsum harum. Maiores voluptate, tempora voluptatibus assumenda dicta voluptatum, omnis quasi iusto molestiae vitae a? Dolorem eaque repellat voluptates velit.\n\n## Bulletpoints\n\n* 1\n* 2\n* 3\n\n[Links](https://v2.felixparadis.com/ask-sagan) and emojis, of course 🕺💃\\\n\\\nAll rendered as from beautiful markdown to beautiful HTML."
                },
                "recursive": true,
                "preload": false,
                "prerender": true
              },
              "path": "/cms/markdown/markdown",
              "id": "_cms_markdown_markdown",
              "component": () => import('../src/pages/cms/markdown/markdown.md').then(m => m.default)
            }
          ],
          "path": "/cms/markdown"
        }
      ],
      "path": "/cms"
    },
    {
      "isPage": true,
      "ownMeta": {
        "index": 0
      },
      "meta": {
        "index": 0,
        "recursive": true,
        "preload": false,
        "prerender": true
      },
      "path": "/homepage",
      "id": "_homepage",
      "component": () => import('../src/pages/homepage.svelte').then(m => m.default)
    },
    {
      "isIndex": true,
      "isPage": true,
      "path": "/index",
      "id": "_index",
      "component": () => import('../src/pages/index.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "ownMeta": {
        "index": 1
      },
      "meta": {
        "index": 1,
        "recursive": true,
        "preload": false,
        "prerender": true
      },
      "path": "/markdown",
      "id": "_markdown",
      "component": () => import('../src/pages/markdown.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "children": [
        {
          "ext": "md",
          "isPage": true,
          "meta": {
            "frontmatter": {
              "name": "Félix Paradis",
              "bio": "That's me.",
              "order": 3,
              "thumbnail": "/images/uploads/portrait.png"
            },
            "recursive": true,
            "preload": false,
            "prerender": true
          },
          "path": "/team/félix-paradis",
          "id": "_team_f_lixParadis",
          "component": () => import('../src/pages/team/félix-paradis.md').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/team/index",
          "id": "_team_index",
          "component": () => import('../src/pages/team/index.svelte').then(m => m.default)
        },
        {
          "ext": "md",
          "isPage": true,
          "meta": {
            "frontmatter": {
              "name": "Jakob Rosenberg",
              "bio": "He helped me one time.\nLook! **bold text** *italic*",
              "order": 1,
              "thumbnail": "/images/uploads/portrait.png"
            },
            "recursive": true,
            "preload": false,
            "prerender": true
          },
          "path": "/team/jakob-rosenberg",
          "id": "_team_jakobRosenberg",
          "component": () => import('../src/pages/team/jakob-rosenberg.md').then(m => m.default)
        },
        {
          "ext": "md",
          "isPage": true,
          "meta": {
            "frontmatter": {
              "name": "Rich Harris",
              "bio": "Oh, you know who he is.",
              "order": 2,
              "thumbnail": "/images/uploads/portrait.png"
            },
            "recursive": true,
            "preload": false,
            "prerender": true
          },
          "path": "/team/rich-harris",
          "id": "_team_richHarris",
          "component": () => import('../src/pages/team/rich-harris.md').then(m => m.default)
        },
        {
          "ext": "md",
          "isPage": true,
          "meta": {
            "frontmatter": {
              "name": "Youuuu?",
              "bio": "idk\n\nlorem ipsum and all",
              "order": 4,
              "thumbnail": "/images/uploads/portrait.png"
            },
            "recursive": true,
            "preload": false,
            "prerender": true
          },
          "path": "/team/youuuu",
          "id": "_team_youuuu",
          "component": () => import('../src/pages/team/youuuu.md').then(m => m.default)
        }
      ],
      "isLayout": true,
      "ownMeta": {
        "index": 4
      },
      "meta": {
        "index": 4,
        "recursive": true,
        "preload": false,
        "prerender": true
      },
      "path": "/team",
      "id": "_team__layout",
      "component": () => import('../src/pages/team/_layout.svelte').then(m => m.default)
    }
  ],
  "isLayout": true,
  "path": "/",
  "id": "__layout",
  "component": () => import('../src/pages/_layout.svelte').then(m => m.default)
}


export const {tree, routes} = buildClientTree(_tree)

